import * as React from 'react';
import { useInView } from 'react-intersection-observer';

import { PlayCircleIcon } from '@notino/react-styleguide';

import ErrorBoundary from '@components/ErrorBoundary';
import { RectanglePlaceholder } from '@components/Placeholders';
import { IImageProperties } from '@helpers/utils';

import { useNewPdDesignEnabled } from '../../hooks/useNewPdDesignEnabled';

import { Border, Div, Img, TopMostDiv, VideoIcon } from './styled';

export interface IImageProps extends IImageProperties {
  onClick?: React.MouseEventHandler<HTMLElement>;
  onMouseOver?: React.EventHandler<React.MouseEvent<HTMLElement>>;
  isSelected: boolean;
}

export const Image: React.FC<IImageProps> = ({
  isVideo,
  onClick,
  onMouseOver,
  ...imageAttributes
}) => {
  const newDesign = useNewPdDesignEnabled();
  const [ref, inView] = useInView({ triggerOnce: true });

  return (
    <ErrorBoundary>
      <TopMostDiv newDesign={newDesign}>
        {imageAttributes.isSelected && newDesign && <Border />}

        <Div
          ref={ref}
          onMouseOver={onMouseOver}
          onClick={onClick}
          newDesign={newDesign}
        >
          {inView ? (
            <Img {...imageAttributes} newDesign={newDesign} />
          ) : (
            <RectanglePlaceholder size={newDesign ? '8.75rem' : '70px'} />
          )}
          {isVideo && (
            <VideoIcon>
              <PlayCircleIcon width="24px" height="24px" color="icon.primary" />
            </VideoIcon>
          )}
        </Div>
      </TopMostDiv>
    </ErrorBoundary>
  );
};
